import React from 'react';
import { Command } from 'cmdk';
import { observer } from 'mobx-react-lite';
import { useMultiSelect } from './multi-select.context';

import './styles/multi-select-option.css';
type ExtractProps = React.ComponentPropsWithRef<typeof Command.Item>;
type MultiSelectOptionProps = Pick<
  ExtractProps,
  'value' | 'className' | 'children' | 'ref'
> & {
  viewValue: string;
};

export const MultiSelectOption = observer(
  ({ children, className, value, viewValue, ref, ...props }: MultiSelectOptionProps) => {
    const multiselectCtx = useMultiSelect();
    return (
      <Command.Item
        ref={ref}
        value={value}
        className="multi-select__option"
        onSelect={(command) => {
          multiselectCtx.onSelect({ value: command, viewValue: viewValue });
          multiselectCtx.close();
        }}
      >
        {children}
      </Command.Item>
    );
  }
);
